import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    SendMessageToEventMutation,
    SendMessageToEventMutationVariables,
} from './SendMessage.mutations.generated'

export const SEND_MESSAGE_TO_EVENT: TypedDocumentNode<
    SendMessageToEventMutation,
    SendMessageToEventMutationVariables
> = gql`
    mutation SendMessageToEvent($input: sendMessageToEventInput!) {
        sendMessageToEvent(input: $input) {
            success
        }
    }
`
